import { render, staticRenderFns } from "./DineInsaleReport.vue?vue&type=template&id=5a20ccfc&scoped=true"
import script from "./DineInsaleReport.vue?vue&type=script&lang=js"
export * from "./DineInsaleReport.vue?vue&type=script&lang=js"
import style0 from "./DineInsaleReport.vue?vue&type=style&index=0&id=5a20ccfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20ccfc",
  null
  
)

export default component.exports